// import { Job } from "core/home/types";
import { UserRaw } from "core/profile/types";
import { RegisterOrganizationParams } from "core/register/types";
import { getClient, ServiceEndpoints } from "lib/http/api";
import { call } from "lib/http/call";
import { encodeToSnakeCase } from "lib/http/formatForServer";
import { ContentType, MethodType } from "lib/http/types";
import {
  PatchUserParams,
  RequestDemoParams,
  RequestDemoResponse,
} from "./types";

export interface RegisterResponse {
  dashboardUsrRefId: string;
  token: string;
}

function decodePayload(data: any): RegisterResponse {
  return {
    dashboardUsrRefId: data.dashboard_usr_ref_id,
    token: data.token,
  };
}

export async function registerWithEmail(
  email: string
): Promise<{
    body: RegisterResponse | null;
    error: string | null;
  }> {
  const formattedBody = encodeToSnakeCase({ email });
  return await getClient()
    .post(`/v1/dashboard/users`, formattedBody)
    .then((res) => {
      const registerRes = decodePayload(res.data);
      return {
        body: registerRes,
        error: null,
      };
    })
    .catch((e: any) => {
      if (e?.message === "Request failed with status code 409") {
        return {
          body: null,
          error: "That email already exists. Please sign in.",
        };
      }
      return {
        body: null,
        error: e?.message ?? "Error registering. Please try again",
      };
    });
}

export async function patchOrgDetails(
  refId: string,
  userDetails: PatchUserParams
): Promise<{
    user: UserRaw | null;
    error: string | null;
  }> {
  const formattedBody = encodeToSnakeCase(userDetails);
  return await getClient()
    .patch(`/v1/dashboard/users/${refId}`, formattedBody)
    .then((res) => {
      const userRes = res.data || {};
      return {
        error: null,
        user: userRes as UserRaw,
      };
    })
    .catch((e: any) => {
      console.warn("error registering email: ", e);
      return {
        error: e,
        user: null,
      };
    });
}

export async function registerOrganization(
  orgDetails: Partial<RegisterOrganizationParams>
): Promise<{
    token: string | null;
    error: string | null;
  }> {
  const formattedBody = encodeToSnakeCase(orgDetails);
  return await getClient()
    .post(`/v1/dashboard/organizations/register`, formattedBody)
    .then((res) => {
      const token = res.data ?? null;
      if (!token) {
        return {
          error: "No token response on register",
          token: null,
        };
      }
      return {
        error: null,
        token: token,
      };
    })
    .catch((e: any) => {
      console.warn("error registering email: ", e);
      return {
        error: e?.message,
        token: null,
      };
    });
}

export const requestDemo = async (params: RequestDemoParams) => {
  return await call<RequestDemoResponse>({
    body: JSON.stringify(encodeToSnakeCase(params)),
    contentType: ContentType.JSON,
    endpoint: `${ServiceEndpoints.BASE_URL}/v1/demos`,
    method: MethodType.POST,
  });
};
